import { render, staticRenderFns } from "./VariantSifterGenesTrack.vue?vue&type=template&id=2ec8f985&scoped=true&"
import script from "./VariantSifterGenesTrack.vue?vue&type=script&lang=js&"
export * from "./VariantSifterGenesTrack.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterGenesTrack.vue?vue&type=style&index=0&id=2ec8f985&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec8f985",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ec8f985')) {
      api.createRecord('2ec8f985', component.options)
    } else {
      api.reload('2ec8f985', component.options)
    }
    module.hot.accept("./VariantSifterGenesTrack.vue?vue&type=template&id=2ec8f985&scoped=true&", function () {
      api.rerender('2ec8f985', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterGenesTrack.vue"
export default component.exports